import axios from 'axios';

const API_BASE = process.env.REACT_APP_API_BASE || 'http://127.0.0.1:8000';

function authHeader() {
  const auth = JSON.parse(localStorage.getItem('zocs_auth') || '{}');
  return { Authorization: `Bearer ${auth.token}` };
}

export async function getZones(filters = {}) {
  const res = await axios.get(`${API_BASE}/warehouse/zones`, { headers: authHeader(), params: filters });
  return res.data;
}

export async function createZone(zoneData) {
  const res = await axios.post(`${API_BASE}/warehouse/zones`, zoneData, { headers: authHeader() });
  return res.data;
}

export async function deactivateZone(zoneId) {
  const res = await axios.delete(`${API_BASE}/warehouse/zones/${zoneId}`, { headers: authHeader() });
  return res.data;
}

export async function getBins(filters = {}) {
  const res = await axios.get(`${API_BASE}/warehouse/bins`, { headers: authHeader(), params: filters });
  return res.data;
}

export async function createBin(binData) {
  const res = await axios.post(`${API_BASE}/warehouse/bins`, binData, { headers: authHeader() });
  return res.data;
}

export async function deactivateBin(binId) {
  const res = await axios.put(`${API_BASE}/warehouse/bins/${binId}`, { is_active: false }, { headers: authHeader() });
  return res.data;
}

export async function getBinItems(binId) {
  const res = await axios.get(`${API_BASE}/warehouse/bins/${binId}/items`, { headers: authHeader() });
  return res.data;
}
